import ClubRole from '../dto/ClubRole.js';
import Error from '../model/Error';
import axios from 'axios';

export default class ClubRoleRepository {
    static findByClub(clubId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/clubs/${clubId}/club-roles`)
                .then(response => resolve(response.data.data.map(clubRole => ClubRole.fromData(clubRole))))
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }
    static update(employeeId, roles) {
        return new Promise((resolve, reject) => {
            axios
                .put(`/club/employees/${employeeId}/club-roles`, roles)
                .then(() => resolve())
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static findByClubAndCurrentUser(clubId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/clubs/${clubId}/club-roles/current-user`)
                .then(response => resolve(response.data.data.map(clubRole => ClubRole.fromData(clubRole))))
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }
}
